export const familyOfficeTypes = [
  { id: "single family office", name: "Single Family Office" },
  { id: "multi family office", name: "Multi Family Office" },
]

export const statuses = [
  {id: "approved", name: "Approved"},
  {id: "pending", name: "Pending"},
  {id: "rejected", name: "Rejected"}
]

export const types = [
  {id: "create", name: "Create"},
  {id: "update", name: "Update"},
]

export const emergingManagers = [
  {id: "yes", name: "Yes"},
  {id: "no", name: "No"},
  {id: "undisclosed", name: "Undisclosed"}
]


